import { StateMode } from './enums';

export const DEFAULT_STATE_MODE: StateMode = StateMode.BACKGROUND;
